import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'
import { useBeforeUnload } from 'react-use'

import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useIsCommentMapDirty } from '~/hooks/jotai'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'

import { commentByViewKeyAtom, savedCommentByViewKeyAtom } from './atoms'
import { WhoAndWhatAnalysis } from './components/WhoAndWhatAnalysis'
import { useResetOnUnmount } from './hooks/useResetOnUnmount'

export const WhoAndWhatAnalysisPage = checkCurrentSurvey(() => {
  const { t } = useTranslation()
  const { isLoading } = useSurveyQuery()
  const isDirty = useIsCommentMapDirty(
    commentByViewKeyAtom,
    savedCommentByViewKeyAtom,
  )
  const dirtyMessage = t(
    'edited_content_has_not_been_saved_do_you_still_want_to_leave',
  )

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  )

  useBeforeUnload(isDirty, dirtyMessage)
  useLogEventOnMount('Access to who and what analysis function')
  useResetOnUnmount()

  React.useEffect(() => {
    if (blocker.state === 'blocked') {
      const isConfirmed = window.confirm(dirtyMessage)
      if (isConfirmed) {
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, dirtyMessage])

  return (
    <Suspense loading={isLoading}>
      <WhoAndWhatAnalysis />
    </Suspense>
  )
})
